import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';

import {
  BukTicketDefaultExpiryDates,
  BukTicketDefaultPeriods,
} from '../../models/buk-ticket.model';

@Component({
  selector: 'app-link-ticket-form',
  templateUrl: './link-ticket-form.component.html',
  styleUrls: ['./link-ticket-form.component.scss'],
})
export class LinkTicketFormComponent implements OnInit {
  @Input() set isUnlimitedTicket(isUnlimitedTicket: boolean) {
    this._isUnlimitedTicket = isUnlimitedTicket;
    this.updateTicketFormGroup(isUnlimitedTicket);
  }

  public _isUnlimitedTicket: boolean;

  @Output() validityChange = new EventEmitter<boolean>();

  @Output() formChange = new EventEmitter<void>();

  @ViewChild('picker') picker: MatDatepicker<Date>;

  public isDatePickerMode = false;

  public periods = BukTicketDefaultPeriods;
  public expiryDates = BukTicketDefaultExpiryDates;

  public ticketFormGroup: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.ticketFormGroup = this.formBuilder.group({
      count: [
        null,
        [Validators.required, Validators.min(1), Validators.max(100000)],
      ],
      expiryDate: ['1m', Validators.required],
      period: ['1m', Validators.required],
    });
  }

  ngOnInit(): void {
    this.ticketFormGroup.valueChanges.subscribe(() => {
      this.validityChange.emit(!this.ticketFormGroup.invalid);
      this.formChange.emit();
    });
  }

  updateTicketFormGroup(isUnlimitedTicket: boolean): void {
    if (isUnlimitedTicket) {
      this.ticketFormGroup = this.formBuilder.group({
        count: [
          null,
          [Validators.required, Validators.min(1), Validators.max(100000)],
        ],
      });
    } else {
      this.ticketFormGroup = this.formBuilder.group({
        count: [
          null,
          [Validators.required, Validators.min(1), Validators.max(100000)],
        ],
        expiryDate: ['1m', Validators.required],
        period: ['1m', Validators.required],
      });
    }
  }

  openDatePicker(): void {
    this.picker.open();
    this.isDatePickerMode = true;
  }

  updateExpiryDate(event: Moment): void {
    this.ticketFormGroup.patchValue({ expiryDate: event });
  }

  resetTicketFormGroup(): void {
    const _resetValue: any = {
      count: null,
    };

    if (!this._isUnlimitedTicket) {
      _resetValue.period = '1m';
      _resetValue.expiryDate = '1m';

      this.isDatePickerMode = false;
    }

    this.ticketFormGroup.reset(_resetValue);
  }
}
